export enum EHoldTypes {
  ADMIN = 'admin',
  DISCIPLINE = 'discipline',
  MEDICAL = 'medical'
}
